// extracted by mini-css-extract-plugin
export var icon = "_43-1";
export var subtext = "_43-0";